<div class="flex-layout center-content">
  <div class="ops-header item-grow" style="display: flex; justify-content: space-between;">
    <a routerLink="/operational-dashboard/orders-by-status">Orders By Status</a>

    @if (!isLoading && !didError) {
      <div class="tree-buttons">
        <button mat-raised-button color="secondary" (click)="collapseAll()">
          <mat-icon>unfold_less</mat-icon>
          <span>Collapse Tree</span>
        </button>
        <button mat-raised-button color="secondary" (click)="expandAll()">
          <mat-icon>unfold_more</mat-icon>
          <span>Expand Tree</span>
        </button>
      </div>
    }
  </div>
</div>

@if (isLoading) {
  <insight-loading-spinner [loadingMessage]="'Loading...'">
  </insight-loading-spinner>
}

@if (hasData() === false && !isLoading) {
  <div class="content-box-content">No orders to show</div>
}

@if (!isLoading && !didError) {
  <div class="content-box-content" style="padding: 1rem;">
    <mat-tree #tree [dataSource]="nodeDataSource" [childrenAccessor]="childrenAccessor" class="tree">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node">
        <li class="mat-tree-node">
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button disabled></button>
          <a class="node-name" [routerLink]="['/']" [queryParams]="node.queryParams">
            {{node.name}} ({{node.nodeMatchesCount}})
          </a>
        </li>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-nested-tree-node *matTreeNodeDef="let node;when: hasChild" [isExpandable]="true" [isExpanded]="true">
        <li>
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            <a class="node-name" [routerLink]="['/']" [queryParams]="node.queryParams">
              {{node.name}} ({{node.nodeMatchesCount}})
            </a>
          </div>
          <ul [class.tree-invisible]="!tree.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
}

@if (!isLoading && didError) {
  <div class="flex-layout center-content">
    <div>
      An error occurred while getting orders by shipment.
    </div>
  </div>
}
